import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { ADD, REMOVE, VIEW_TYPES, BED_DETAILS_MODULE, DEVICE_TYPES, DEVICE_LABELS, USER_VIEW } from "../../common/constant/common-constants";
import AnimateBed from "../../common/utils/Animations/AnimateBed";
import { activeDeviceAction, favoriteBedAction, selectedBedAction } from "../../modules/actions/action";
import BedDataContainer from "../BedDataContainer/BedDataContainer";
import "./BedContainer.scss";
import PatientRightPanel from "../PatientRightPanel/PatientRightPanel";
import { bedDetailConfigAction, viewTypeAction } from "../../modules/actions/action";
import { configReducer } from "../../modules/reducers/config-reducer";
import { setbedCartViewRedisChannels } from '../../socket/socket';
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import allGridIcon from "../../common/images/all.png";
import groupByIcon from "../../common/images/groupBy.png";

const padCount = (count) => String(count).padStart( 1, "0");

function BedContainer(props) {

    const [lvSelectedBed, setLvSelectedBed] = useState(props.selectedBed);
    const [bedArray, setBedArray] = useState([]);
    const [layoutMode, setLayoutMode] = useState("all");
    const [deviceType, setDeviceType] = useState(DEVICE_TYPES.VENTILATOR);
    const bedCardRefs = useRef({});
    const leftPanelRef = useRef(null);

    useEffect(() => {
        sortForFavorite();
    }, [props.favoriteBedIdArray])

    useEffect(() => {

        sortForFavorite();
        if (props.bedIdArray && props.bedIdArray.length > 0) {
            if (!lvSelectedBed && props.config.viewType === VIEW_TYPES.LIST_VIEW) {
                setLvSelectedBed(props.bedIdArray[0]);
                console.log("this runs on no lvselected");
                props.selectedBedAction(props.bedIdArray[0]);
            };
        }
    }, [props.bedIdArray]);

    useEffect(() => {
        setLvSelectedBed(props.selectedBed);
    }, [])

    const sortForFavorite = () => {
        const favBedArray = props.favoriteBedIdArray;
        let currentBedIdArray = [...props.bedIdArray];
        let bd = (currentBedIdArray && currentBedIdArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
        setBedArray((prev) => {
            if (prev.length === bd.length && prev.every((id, i) => id === bd[i])) {
                return prev;
            }
            return bd;
        });
    }

    const handleFavoriteClick = (event, type, bedId) => {
        event.stopPropagation();

        let arr = props.favoriteBedIdArray;
        let index = arr.indexOf(bedId);
        switch (type) {
            case ADD:
                if (index < 0) {
                    arr.push(bedId);
                }
                break;
            case REMOVE:
                if (index > -1) {
                    arr.splice(index, 1);
                }
                break;
            default:
                break;
        }

        props.favoriteBedAction([...arr]);

    }

    const getWardBedIds = () => {
        return (bedArray || []).filter((id) =>
            props.wardData?.bedList && props.wardData.bedList.indexOf(id) >= 0
        );
    };

    const getDeviceStatus = (bedId) => {
        if (deviceType === DEVICE_TYPES.NOCCARC_PM_NX5) {
            return props.monitorHeartbeat?.[bedId]?.isConnected ? "active" : "disconnected";
        }

        const heartbeat = props.ventilatorHeartbeat?.[bedId];
        const standby = props.ventilatorStandby?.[bedId];
        const ventilatorConnected = heartbeat?.isConnected;
        const userEnabled = heartbeat?.user_enabled;
        const ventilationStatus = standby?.ventilationStatus;

        if (ventilatorConnected && userEnabled && ventilationStatus) return "active";
        if (ventilatorConnected && userEnabled) return "standby";
        return "disconnected";
    };

    const getStatusCounts = (ids) => {
        const counts = { active: 0, standby: 0, disconnected: 0 };
        ids.forEach((id) => {
            counts[getDeviceStatus(id)] += 1;
        });
        return counts;
    };

    const getBedsByStatus = (ids) => {
        const groups = { active: [], standby: [], disconnected: [] };
        ids.forEach((id) => {
            groups[getDeviceStatus(id)].push(id);
        });
        return groups;
    };

    const handleNotificationClick = (bedId) => {
        // console.log(`notification icon clicked for ${bedId}`);
    }

    useLayoutEffect(() => {
        if (props.config?.viewType !== VIEW_TYPES.LIST_VIEW) return;
        const panel = leftPanelRef.current;
        if (!panel || !lvSelectedBed) return;
        panel.scrollTop = 0;
    }, [lvSelectedBed, props.config?.viewType]);
    // console.log("config", props.config);
    const handleBedClick = (id) => {

        if (!props?.bedDetails[id]?.Noccarc_patientMonitorId && !props?.bedDetails[id]?.ventilatorId) return
        if (lvSelectedBed === id) return
        props.activeDeviceAction(null)
        setLvSelectedBed(id);
        props.selectedBedAction(id);

        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.VITAL_DETAILS
        })
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const handleCrossClick = () => {
        setLvSelectedBed(null);
        props.activeDeviceAction(null);
        props.selectedBedAction(null);
        props.viewTypeAction({
            viewType: VIEW_TYPES.GRID_VIEW
        })
        // setbedCartViewRedisChannels(props.selectedWard.id);

    }

    const handleAlarmMoreClick = (id) => {
        setLvSelectedBed(id);

        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.ALARMS
        });
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const handleAddPatientClick = (id) => {
        setLvSelectedBed(id);
        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.PATIENT_DETAILS
        });
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const getBedCardRef = (id) => {
        if (!bedCardRefs.current[id]) {
            bedCardRefs.current[id] = React.createRef();
        }
        return bedCardRefs.current[id];
    };

    const renderBedCard = (id) => {
        if (props.wardData && props.wardData.bedList && (props.wardData.bedList.indexOf(id) >= 0)) {
            return (
                <BedDataContainer
                    key={id}
                    bedId={id}
                    handleFavoriteClick={(event, type, bedId) => handleFavoriteClick(event, type, bedId)}
                    isFavorite={props.favoriteBedIdArray && props.favoriteBedIdArray.indexOf(id) > -1}
                    isSelected={lvSelectedBed}
                    handleBedClick={() => handleBedClick(id)}
                    handleNotificationClick={(bedId) => handleNotificationClick(bedId)}
                    handleAlarmMoreClick={() => handleAlarmMoreClick(id)}
                    handleAddPatientClick={() => handleAddPatientClick(id)}
                    ref={getBedCardRef(id)}
                />);
        }
        return null;
    };

    const getBedArray = (ids) => {
        if (!ids) return;
        let tempBedArray = [...ids];

        // to render at the top of the list for the selected bed
        if (lvSelectedBed && tempBedArray && props.config.viewType == VIEW_TYPES.LIST_VIEW) {
            const selectedIndex = tempBedArray.indexOf(lvSelectedBed);
            if (selectedIndex > -1) {
                let tempEle = tempBedArray.splice(selectedIndex, 1)[0];
                tempBedArray.unshift(tempEle)
            }
        }

        return tempBedArray.map((id) => renderBedCard(id));
    }

    const renderStatusBadge = (label, count, className) => (
        <span className={`status-badge ${className}`}>
            {label} {padCount(count)}
        </span>
    );

    const renderStatusCounts = (counts) => (
        <div className="bed-status-counts">
            {renderStatusBadge("ACTIVE", counts.active, "active")}
            {deviceType === DEVICE_TYPES.VENTILATOR && renderStatusBadge("STAND BY", counts.standby, "standby")}
            {renderStatusBadge("NOT CONNECTED", counts.disconnected, "disconnected")}
        </div>
    );

    const renderGridToolbar = (counts) => (
        <div className={`bed-grid-toolbar${layoutMode === "group" ? " bed-grid-toolbar--group" : ""}`}>
            {layoutMode === "all" ? renderStatusCounts(counts) : null}
            <div className="bed-grid-filters">
                <button
                    type="button"
                    className={`grid-filter-btn${layoutMode === "all" ? " selected" : ""}`}
                    onClick={() => setLayoutMode("all")}
                >
                    All
                    <img className="grid-filter-icon" src={allGridIcon} alt="" aria-hidden="true" />
                </button>
                <button
                    type="button"
                    className={`grid-filter-btn${layoutMode === "group" ? " selected" : ""}`}
                    onClick={() => setLayoutMode("group")}
                >
                    Group By
                    <img className="grid-filter-icon" src={groupByIcon} alt="" aria-hidden="true" />
                </button>
                <div className="device-type-select">
                    <CustomSelect
                        id="device-type"
                        className="grid-device-type-select"
                        variant="grid"
                        value={{ value: deviceType, label: DEVICE_LABELS[deviceType] }}
                        handleChange={(item) => setDeviceType(item.value)}
                        label="label"
                        isClearable={false}
                        options={Object.values(DEVICE_TYPES).map((type) => ({
                            value: type,
                            label: DEVICE_LABELS[type],
                        }))}
                        placeholder="Device Type"
                        backgroundColor="#1a1a1a"
                        isSearchable={false}
                        singleValFontSize="0.729vw"
                        controlHeight="3.333vh"
                        paddingValueContainer="0 0.625vw"
                    />
                </div>
            </div>
        </div>
    );

    const renderGroupedGrid = (groups) => {
        const sections = deviceType === DEVICE_TYPES.VENTILATOR
            ? [
                { key: "active", label: "ACTIVE", className: "active", ids: groups.active },
                { key: "standby", label: "STAND BY", className: "standby", ids: groups.standby },
                { key: "disconnected", label: "NOT CONNECTED", className: "disconnected", ids: groups.disconnected },
            ]
            : [
                { key: "active", label: "ACTIVE", className: "active", ids: groups.active },
                { key: "disconnected", label: "NOT CONNECTED", className: "disconnected", ids: groups.disconnected },
            ];

        return (
            <div className="bed-grid-grouped">
                {sections.map((section) => (
                    section.ids.length > 0 && (
                    <div className="bed-status-section" key={section.key}>
                        <div className="bed-status-section-header">
                            {renderStatusBadge(section.label, section.ids.length, section.className)}
                            <span className="bed-status-section-header-line" aria-hidden="true" />
                        </div>
                        <div className="bed-grid-data-container grouped">
                            {section.ids.map((id) => renderBedCard(id))}
                        </div>
                    </div>
                    )
                ))}
            </div>
        );
    }


    //Set the socket context when ward is changed
    useEffect(() => {

        if (props.selectedWard && props.selectedWard.id && props.config.viewType === VIEW_TYPES.GRID_VIEW) setbedCartViewRedisChannels(props.selectedWard.id);
    }, [props.selectedWard, props.config.viewType]);

    return (
        <>
            <div
                className={`bed-container${
                    props.config?.viewType === VIEW_TYPES.GRID_VIEW ? " bed-container--grid" : ""
                }`}
            >
                {props.config.userView === USER_VIEW.DESKTOP && (
                    <>
                        {props.config.viewType === VIEW_TYPES.LIST_VIEW ? (
                            <div className="bed-left-panel" ref={leftPanelRef}>
                                {getBedArray(bedArray)}
                            </div>
                        ) : (
                            <div className="bed-grid-shell">
                                {renderGridToolbar(getStatusCounts(getWardBedIds()))}
                                <div className="bed-grid-scroll">
                                    {layoutMode === "group" ? (
                                        renderGroupedGrid(getBedsByStatus(getWardBedIds()))
                                    ) : (
                                        <div className="bed-grid-data-container">
                                            {getBedArray(bedArray)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {props.config.viewType === VIEW_TYPES.LIST_VIEW && (
                            <div className="right-panel">
                                <PatientRightPanel
                                    wardId={props.selectedWard.id}
                                    bedId={lvSelectedBed}
                                    handleCrossClick={handleCrossClick}
                                />
                            </div>
                        )}
                    </>
                )}

                {props.config.userView === USER_VIEW.MOBILE &&
                    (props.config.viewType === VIEW_TYPES.LIST_VIEW ? (
                        <PatientRightPanel
                            wardId={props.selectedWard.id}
                            bedId={lvSelectedBed}
                            handleCrossClick={handleCrossClick}
                        />
                    ) : (
                        <div className="bed-card-mobile-view-container">
                            <AnimateBed>
                                {getBedArray(bedArray)}
                            </AnimateBed>
                        </div>
                    ))
                }



            </div>
        </>
    );
}



const mapStateToProps = (state, ownProps) => {
    let wardData = state.wardDetailsReducer.wardData && state.wardDetailsReducer.wardData[ownProps.selectedWard.id];
    let bedDetails = state.bedDetailsReducer.bedDetails;


    return {
        bedDetails: bedDetails,
        bedIdArray: state.bedDetailsReducer.bedIdArray,
        selectedBed: state.bedDetailsReducer.selectedBed,
        wardData: wardData,
        config: state.configReducer.config,
        config: state.configReducer.config,
        favoriteBedIdArray: state.bedDetailsReducer.favoriteBedIdArray || [],
        ventilatorHeartbeat: state.deviceVitalDataReducer?.ventilatorHeartbeat || {},
        ventilatorStandby: state.deviceVitalDataReducer?.ventilatorStandby || {},
        monitorHeartbeat: state.deviceVitalDataReducer?.monitorHeartbeat || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        favoriteBedAction: (payload) => dispatch(favoriteBedAction(payload)),
        activeDeviceAction: (payload) => dispatch(activeDeviceAction(payload)),
        bedDetailConfigAction: (payload) => dispatch(bedDetailConfigAction(payload)),
        viewTypeAction: (payload) => dispatch(viewTypeAction(payload)),
        configReducer: (payload) => dispatch(configReducer(payload)),
        selectedBedAction: (payload) => dispatch(selectedBedAction(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BedContainer);